import type React from "react";

const HTMLTable = (props: { children?: React.ReactNode }) => <table data-component="table">{props.children}</table>;

export default HTMLTable;
